import { generateTestId } from "@client-shared";

export const setAlertsInsightsTestId = (identifier: string): string =>
  generateTestId("AlertsInsights", identifier);

// Specific testId setters for tests
export const setAlertsInsightsContainerTestId = (): string =>
  setAlertsInsightsTestId("container");
export const setAlertsInsightsTitleTestId = (): string =>
  setAlertsInsightsTestId("title");
export const setAlertsInsightsViewAllTestId = (): string =>
  setAlertsInsightsTestId("view-all");
